module.exports = __webpack_public_path__ + "img/klocki.95d7e231.svg";